<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white"> Please Wait... </p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Events Details

        <div>
            <button mat-raised-button color="primary" style="font-size: 14px;
                    margin-right: 15px;" (click)="Add_Event()"><mat-icon>add</mat-icon>Add</button>
        </div>

    </div>
</div>


<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="event_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID. </th>
                <td mat-cell *matCellDef="let element"> {{element.event_id}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="event_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.event_name}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="event_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                <td mat-cell *matCellDef="let element"> {{element.event_type}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
                <td mat-cell *matCellDef="let element" matTooltipPosition="above" matTooltip=" {{element.description}}"
                    style=" max-width: 200px;">
                    {{element.description}} </td>
            </ng-container>

            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
                <td mat-cell *matCellDef="let element"> {{element.address}} </td>
            </ng-container>

            <ng-container matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created By </th>
                <td mat-cell *matCellDef="let element"> {{element.created_by}} </td>
            </ng-container>

            <ng-container matColumnDef="created_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date </th>
                <td mat-cell *matCellDef="let element"> {{element.created_date | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="from_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> From Date </th>
                <td mat-cell *matCellDef="let element"> {{element.from_date| date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="to_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> To Date </th>
                <td mat-cell *matCellDef="let element"> {{element.to_date | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="event_logo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Logo</th>
                <td mat-cell *matCellDef="let element">
                    <img [src]="element.event_logo" style="width: 70px;height: 70px;">
                </td>
            </ng-container>

            <ng-container matColumnDef="event_image">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Image</th>
                <td mat-cell *matCellDef="let element">
                    <img src="{{element.event_image}}" style="width: 70px;height: 70px;">
                </td>
            </ng-container>

            <ng-container matColumnDef="from_time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> From Time </th>
                <td mat-cell *matCellDef="let element"> {{element.from_time}} </td>
            </ng-container>

            <ng-container matColumnDef="to_time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> To Time </th>
                <td mat-cell *matCellDef="let element"> {{element.to_time}} </td>
            </ng-container>
            <ng-container matColumnDef="is_active">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Is Active? </th>
                <td mat-cell *matCellDef="let element"> {{element.is_active}} </td>
                <!-- <td mat-cell *matCellDef="let element"> <mat-checkbox [(ngModel)]="element.is_active"
                        (change)="onCheckboxChange($event, element)">
                    </mat-checkbox></td> -->
            </ng-container>
            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="primary" matTooltip="Edit" style="margin-right: 5px;"
                        (click)="Edit_Event(element.event_id)">
                        <mat-icon class="m-0">edit</mat-icon>
                    </button>

                    <button mat-raised-button color="warn" matTooltip="Delete" style="margin-left: 5px;"
                        (click)="DeleteEvent(element.event_id)">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
</div>